import { Encounter } from '../types/encounter'

/**
 * Returns true when the billing team's supply log review is complete:
 * all CDI-confirmed and manually added supply entries have a revenue code assigned,
 * or there are no billable supplies on the encounter.
 */
export const isSupplyLogReviewComplete = (encounter: Encounter): boolean => {
  const supplyLog = encounter.supplyLog ?? []
  const confirmed = supplyLog.filter(e => e.confirmedByProvider)
  const manual = encounter.manualBillingSupplies ?? []
  const assignments = encounter.billingSupplyAssignments ?? {}

  if (confirmed.length === 0 && manual.length === 0) return true
  const allCdiAssigned = confirmed.every(e => !!assignments[e.id]?.revenueCode)
  const allManualAssigned = manual.every(e => !!e.revenueCode)
  return allCdiAssigned && allManualAssigned
}
